/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/router';
import * as i2 from '../../app/app.component';
import * as i3 from '@ngx-translate/core/src/translate.service';
import * as i4 from '../../app/shared/auth/auth.service';
import * as i5 from '../../app/shared/user/user.service';
import * as i6 from '@angular/platform-browser';
import * as i7 from '../../app/app-loader/config-loader.service';
const styles_AppComponent:any[] = ([] as any[]);
export const RenderType_AppComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(16777216,(null as any),(null as any),1,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(212992,(null as any),0,i1.RouterOutlet,[i1.ChildrenOutletContexts,i0.ViewContainerRef,
          i0.ComponentFactoryResolver,[8,(null as any)],i0.ChangeDetectorRef],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'app-root',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i0.ɵdid(49152,(null as any),0,i2.AppComponent,[i3.TranslateService,i1.Router,
          i4.AuthService,i5.UserService,i6.Title,i7.ConfigLoaderService],(null as any),
          (null as any))],(null as any),(null as any));
}
export const AppComponentNgFactory:i0.ComponentFactory<i2.AppComponent> = i0.ɵccf('app-root',
    i2.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9jaHJvbm9jYXNoVjMvcGFwL3dlYmFwcC1jbGsvc3JjL2FwcC9hcHAuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci9jaHJvbm9jYXNoVjMvcGFwL3dlYmFwcC1jbGsvc3JjL2FwcC9hcHAuY29tcG9uZW50LnRzIiwibmc6Ly8vdmFyL2Nocm9ub2Nhc2hWMy9wYXAvd2ViYXBwLWNsay9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50Lmh0bWwiLCJuZzovLy92YXIvY2hyb25vY2FzaFYzL3BhcC93ZWJhcHAtY2xrL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cy5BcHBDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+IiwiPGFwcC1yb290PjwvYXBwLXJvb3Q+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTthQUFBO3NDQUFBO1VBQUE7SUFBQTs7OztvQkNBQTtNQUFBO2FBQUE7dUVBQUE7VUFBQTs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.component.ngfactory.ts